/**
 * PDP Color Switch - Instant color switching without page reload
 * Uses OAProductsApi for GraphQL product fetching with caching
 * Falls back to normal navigation if JS fails to load
 */
(function() {
  'use strict';

  var currentHandle = null;
  var switching = false;
  var lang = document.documentElement.lang === 'de' ? 'de' : 'en';

  // --- Helpers ---

  function getHandleFromUrl() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function formatMoney(cents) {
    var format = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals}}', String(Math.round(cents / 100)))
      .replace('{{amount_no_decimals_with_comma_separator}}', String(Math.round(cents / 100)));
  }

  function parseTitleParts(title) {
    var parts = title.split(' | ');
    return {
      baseName: (parts[0] || '').trim(),
      colorName: (parts[1] || '').trim()
    };
  }

  function hasTag(tags, tag) {
    if (!tags) return false;
    if (Array.isArray(tags)) return tags.indexOf(tag) !== -1;
    return false;
  }

  var crossOutSvg = '<svg class="oa-cross-out-svg"><line class="line" x1="0" y1="100%" x2="100%" y2="0"></line></svg>';

  // --- Updaters ---

  function updateTitle(product) {
    var parts = parseTitleParts(product.title);
    var h1 = document.querySelector('.product-title');
    if (h1) {
      var subline = h1.querySelector('.product-subline__0');
      // Set base name text (first child text node)
      var textNode = h1.firstChild;
      if (textNode && textNode.nodeType === 3) {
        textNode.textContent = parts.baseName + '\n';
      } else {
        // Rebuild
        h1.innerHTML = '';
        h1.appendChild(document.createTextNode(parts.baseName));
        subline = document.createElement('p');
        subline.className = 'product-subline__0 hidden';
        h1.appendChild(subline);
      }
      if (subline) {
        subline.textContent = parts.colorName;
      }
    }
  }

  function updateColorName(product) {
    var parts = parseTitleParts(product.title);
    var el = document.getElementById('fashion-color-switch-item-title');
    if (el) el.textContent = parts.colorName;
  }

  function updateUrl(handle, pushState) {
    var newUrl = '/products/' + handle;
    if (pushState !== false) {
      history.pushState({ handle: handle }, '', newUrl);
    }
    // Update canonical link
    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.href = window.location.origin + newUrl;
    // Update page title
    var parts = parseTitleParts(document.querySelector('.product-title') ? document.querySelector('.product-title').textContent : '');
    document.title = parts.baseName + (parts.colorName ? ' | ' + parts.colorName : '');
  }

  function updateActiveColorSwatch(handle) {
    // Deactivate all swatches
    var swatches = document.querySelectorAll('#fashion-color-switch .item, #fashion-color-switch .sidebar--color-item-box');
    for (var i = 0; i < swatches.length; i++) {
      swatches[i].classList.remove('active');
      // Check if this swatch matches the handle
      var link = swatches[i].querySelector('a[id^="variant-"]');
      if (link && link.id === 'variant-' + handle) {
        swatches[i].classList.add('active');
      }
    }
    // Also check sidebar swatches
    var sidebarItems = document.querySelectorAll('.sidebar--color-item-bg[data-handle]');
    for (var j = 0; j < sidebarItems.length; j++) {
      var parent = sidebarItems[j].closest('.sidebar--color-item');
      if (parent) {
        parent.classList.remove('active');
        if (sidebarItems[j].dataset.handle === '/products/' + handle || sidebarItems[j].dataset.handle === handle) {
          parent.classList.add('active');
        }
      }
    }
  }

  function updateFormProductId(product) {
    var form = document.getElementById('add-to-cart-form');
    if (form) form.setAttribute('data-productid', product.id);

    var selects = document.querySelectorAll('select[data-productid], input[data-productid]');
    for (var i = 0; i < selects.length; i++) {
      selects[i].setAttribute('data-productid', product.id);
    }
  }

  function updatePrice(product) {
    var priceEl = document.querySelector('[data-price-target]');
    var compareEl = document.querySelector('[data-price-compare-target]');
    var offEl = document.querySelector('[data-price-off-target]');

    if (!priceEl) return;

    // Mirror product-price.liquid: while the campaign is active, a variant whose price_target sits
    // below its price shows PA pricing (compare = regular price, price = PA price) plus the
    // "Price on Summer Sale" label. Not login-gated here — matches the Liquid `{% if pa_script_active %}`.
    var paCents = (window.oaPaScriptActive && product.meta && product.meta.custom)
      ? parseInt(product.meta.custom.price_target, 10)
      : NaN;
    var paActive = Number.isFinite(paCents) && paCents > 0 && paCents < product.price;

    var price, compareAt, hasDiscount;
    if (paActive) {
      price = paCents;
      compareAt = product.price;
      hasDiscount = true;
    } else {
      price = product.price;
      compareAt = product.compare_at_price;
      hasDiscount = compareAt && compareAt > price;
    }

    priceEl.textContent = formatMoney(price);
    priceEl.setAttribute('data-price', price);

    if (hasDiscount) {
      priceEl.classList.add('product-price__price--has-compare');
    } else {
      priceEl.classList.remove('product-price__price--has-compare');
    }

    if (compareEl) {
      if (hasDiscount) {
        compareEl.textContent = formatMoney(compareAt);
        compareEl.setAttribute('data-price-compare', compareAt);
        compareEl.style.display = '';
      } else {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
      }
    }

    if (offEl) {
      if (hasDiscount) {
        var pct = Math.round((1 - price / compareAt) * 100);
        offEl.textContent = lang === 'de' ? ('-' + pct + '%') : (pct + '% OFF');
        offEl.style.display = '';
      } else {
        offEl.textContent = '';
        offEl.style.display = 'none';
      }
    }

    updatePaInfoLabel(priceEl, paActive);
  }

  // Show/refresh or hide the "Price on Summer Sale" label below the price, matching
  // product-price.liquid. The element may be absent server-side (only rendered when PA applied on
  // first paint), so create it on demand when switching to a PA variant.
  function updatePaInfoLabel(priceEl, paActive) {
    var container = priceEl.closest('.product-price');
    if (!container) return;
    var label = container.querySelector('.product-price__price-pa-info');
    if (paActive) {
      if (!label) {
        label = document.createElement('div');
        label.className = 'product-price__price-pa-info';
        container.appendChild(label);
      }
      label.textContent = lang === 'de' ? 'Preis im Summer Sale' : 'Price in Summer Sale';
      label.style.display = '';
    } else if (label) {
      label.style.display = 'none';
    }
  }

  function activateLazyPicture(picture) {
    // Convert data-srcset → srcset on <source> elements so the browser loads them
    var sources = picture.querySelectorAll('source[data-srcset]');
    for (var s = 0; s < sources.length; s++) {
      sources[s].srcset = sources[s].getAttribute('data-srcset');
      sources[s].removeAttribute('data-srcset');
    }
    // Convert data-src → src on <img>
    var img = picture.querySelector('img[data-src]');
    if (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
      img.classList.remove('lazy');
      img.classList.add('loaded');
    }
  }


  function updateDesktopImages(html) {
    var container = document.querySelector('.oa-fashion__product-image-container');
    if (!container) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newContainer = doc.querySelector('.oa-fashion__product-image-container');
    if (!newContainer) return;

    // Preserve the badges element
    var badges = container.querySelector('.oa-fashion-badges-left');
    var badgesHtml = badges ? badges.outerHTML : '';

    container.innerHTML = newContainer.innerHTML + badgesHtml;

    var pictures = container.querySelectorAll('picture');
    for (var p = 0; p < pictures.length; p++) {
      activateLazyPicture(pictures[p]);
    }
    if (window.lazyLoadInstance) window.lazyLoadInstance.update();
  }

  function updateMobileSlider(html) {
    var sliderEl = document.getElementById('product_image_slider_mobile');
    if (!sliderEl) return;

    if (sliderEl.swiper) sliderEl.swiper.destroy(true, true);
    var thumbsEl = document.querySelector('[id$="_thumbs"]');
    if (thumbsEl && thumbsEl.swiper) thumbsEl.swiper.destroy(true, true);

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newWrapper = doc.querySelector('#product_image_slider_mobile .swiper-wrapper');
    var wrapper = sliderEl.querySelector('.swiper-wrapper');
    if (wrapper && newWrapper) wrapper.innerHTML = newWrapper.innerHTML;

    if (thumbsEl) {
      var newThumbsWrapper = doc.querySelector('[id$="_thumbs"] .swiper-wrapper');
      var thumbsWrapper = thumbsEl.querySelector('.swiper-wrapper');
      if (thumbsWrapper && newThumbsWrapper) thumbsWrapper.innerHTML = newThumbsWrapper.innerHTML;
    }

    initMobileSlider();
    if (window.lazyLoadInstance) window.lazyLoadInstance.update();
  }

  function initMobileSlider() {
    if (typeof Swiper === 'undefined') return;
    var sliderEl = document.getElementById('product_image_slider_mobile');
    if (!sliderEl) return;

    var thumbsEl = document.querySelector('[id$="_thumbs"]');
    var thumbs = {};

    if (thumbsEl) {
      var thumbSlides = thumbsEl.querySelectorAll('.swiper-slide:not(.hidden)');
      var thumbsPerView = Math.min(thumbSlides.length, 5) || 5;
      var thumbsSwiper = new Swiper(thumbsEl, {
        spaceBetween: 5,
        slidesPerView: thumbsPerView,
        watchSlidesProgress: true,
        lazyLoad: true
      });
      thumbs = { swiper: thumbsSwiper };
    }

    new Swiper(sliderEl, {
      on: {
        click: function(event) {
          if (window.oaProductZoom) window.oaProductZoom.show(event.target);
        }
      },
      navigation: {
        nextEl: '#product_image_slider_mobile .oa-product-image-slider__nav-next',
        prevEl: '#product_image_slider_mobile .oa-product-image-slider__nav-prev',
        disabledClass: 'oa-product-image-slider__nav--disabled',
        hiddenClass: 'oa-product-image-slider__nav--disabled'
      },
      scrollbar: {
        el: '.oa-product-image-slider__scrollbar',
        dragClass: 'oa-product-image-slider__scrollbar-drag',
        draggable: false
      },
      slidesPerView: 1,
      spaceBetween: 10,
      roundLengths: true,
      mousewheel: { forceToAxis: true, releaseOnEdges: true, invert: true },
      lazyLoad: { enabled: true, loadPrevNext: true },
      thumbs: thumbs
    });
  }

  function updateBadges(product) {
    var tags = product.tags || [];

    // Determine badge state from tags
    var isNew = hasTag(tags, 'new');
    var isRestocked = hasTag(tags, 'restocked');
    var comingSoon = hasTag(tags, 'coming-soon') || hasTag(tags, window.oaComingSoonHideTag);
    var fitsSmall = hasTag(tags, 'fits-small');
    var improvedFit = hasTag(tags, 'improved-fit');
    var runsLarge = hasTag(tags, 'runs-large');
    var soldOut = !product.available;
    // PA (price_target) drives the badge for logged-in customers during the sale; otherwise fall
    // back to compare_at_price. paActive gates the summer-sale date suffix on the badge.
    var paCents = (window.oaPaScriptActive && window.oaIsLoggedIn && product.meta && product.meta.custom)
      ? parseInt(product.meta.custom.price_target, 10)
      : NaN;
    var paActive = Number.isFinite(paCents) && paCents > 0 && paCents < product.price;
    var hasDiscount, discountPct;
    if (paActive) {
      hasDiscount = true;
      discountPct = Math.round((1 - paCents / product.price) * 100);
    } else {
      hasDiscount = product.compare_at_price && product.compare_at_price > product.price;
      discountPct = hasDiscount ? Math.round((1 - product.price / product.compare_at_price) * 100) : 0;
    }

    // Update top-new-badge (above title)
    var topBadge = document.querySelector('.top-new-badge');
    if (topBadge) {
      if (isRestocked) {
        topBadge.textContent = 'Restocked';
        topBadge.style.display = '';
      } else if (comingSoon) {
        topBadge.textContent = lang === 'de' ? 'Bald erhältlich' : 'Coming Soon';
        topBadge.style.display = '';
      } else if (isNew) {
        topBadge.textContent = lang === 'de' ? 'Neu' : 'New';
        topBadge.style.display = '';
      } else {
        topBadge.style.display = 'none';
      }
    }

    // Update desktop image badges (left side)
    updateImageBadges('.oa-fashion__product-image-container .oa-fashion-badges-left', {
      hasDiscount: hasDiscount, discountPct: discountPct, soldOut: soldOut, paActive: paActive,
      isNew: isNew, isRestocked: isRestocked, comingSoon: comingSoon,
      fitsSmall: fitsSmall, improvedFit: improvedFit, runsLarge: runsLarge
    });

    // Update mobile image badges
    updateImageBadges('.visible-sm .oa-fashion-badges-left, .visible-xs .oa-fashion-badges-left', {
      hasDiscount: hasDiscount, discountPct: discountPct, soldOut: soldOut, paActive: paActive,
      isNew: isNew, isRestocked: isRestocked, comingSoon: comingSoon,
      fitsSmall: fitsSmall, improvedFit: improvedFit, runsLarge: runsLarge
    });
  }

  function updateImageBadges(selector, state) {
    var containers = document.querySelectorAll(selector);
    for (var c = 0; c < containers.length; c++) {
      var container = containers[c];
      var html = '';

      // Desktop PDP badges (pdp_desktop layout)
      var isDesktop = container.closest('.oa-fashion__product-image-container') !== null;

      if (isDesktop) {
        // Desktop: fits_small, improved_fit, runslarge on right; discount on left
        if (state.fitsSmall) html += '<div class="fashion-badge fashion-badge--right fashion-badge--black">' + (lang === 'de' ? 'Fällt klein aus' : 'Fits small') + '</div>';
        if (state.improvedFit) html += '<div class="fashion-badge fashion-badge--right fashion-badge--black">' + (lang === 'de' ? 'Optimierte Passform' : 'Improved fit') + '</div>';
        if (state.runsLarge) html += '<div class="fashion-badge fashion-badge--right fashion-badge--black">' + (lang === 'de' ? 'Fällt gross aus' : 'RUNS LARGE') + '</div>';
        if (state.hasDiscount && !state.soldOut) {
          var pctText = lang === 'de' ? ('-' + state.discountPct + '%') : (state.discountPct + '% OFF');
          if (window.oaPaScriptActive && window.oaComingSoonDate) {
            pctText += (lang === 'de' ? ' AB ' : ' ON ') + window.oaComingSoonDate;
          }
          html += '<div class="fashion-badge fashion-badge--left fashion-badge--white">' + pctText + '</div>';
        }
      } else {
        // Mobile / PLP badges
        if (state.hasDiscount && !state.soldOut) {
          var pctText = lang === 'de' ? ('-' + state.discountPct + '%') : (state.discountPct + '% OFF');
          if (window.oaPaScriptActive && window.oaComingSoonDate) {
            pctText += (lang === 'de' ? ' AB ' : ' ON ') + window.oaComingSoonDate;
          }
          html += '<div class="fashion-badge fashion-badge--left fashion-badge--white">' + pctText + '</div>';
        }
        if (state.isRestocked) {
          html += '<div class="fashion-badge fashion-badge--left fashion-badge--white fashion-badge--left-restocked">Restocked</div>';
        } else if (state.comingSoon) {
          html += '<div class="fashion-badge fashion-badge--left fashion-badge--white">' + (lang === 'de' ? 'Bald erhältlich' : 'Coming Soon') + '</div>';
        } else if (state.isNew) {
          html += '<div class="fashion-badge fashion-badge--left fashion-badge--white">' + (lang === 'de' ? 'Neu' : 'New') + '</div>';
        }
        if (state.soldOut && !state.comingSoon) {
          html += '<div class="fashion-badge fashion-badge--black" data-badge="sold-out">' + (lang === 'de' ? 'Ausverkauft' : 'Sold out') + '</div>';
        }
        if (state.fitsSmall) html += '<div class="fashion-badge fashion-badge--left fashion-badge--white">' + (lang === 'de' ? 'Fällt klein aus' : 'Fits small') + '</div>';
        if (state.improvedFit) html += '<div class="fashion-badge fashion-badge--left fashion-badge--white">' + (lang === 'de' ? 'Optimierte Passform' : 'Improved fit') + '</div>';
        if (state.runsLarge) html += '<div class="fashion-badge fashion-badge--left fashion-badge--white">' + (lang === 'de' ? 'Fällt gross aus' : 'RUNS LARGE') + '</div>';
      }

      container.innerHTML = html;
    }
  }

  function ensureVariantScaffold(product) {
    if (!product.available) return;
    var variantsContainer = document.querySelector('.fashion-info-sticky .product-variants');
    if (!variantsContainer) return;

    if (!variantsContainer.querySelector('.product-sizes-container')) {
      var row = document.createElement('div');
      row.className = 'row variant-row';
      var col = document.createElement('div');
      col.className = 'col-xs-12 product-sizes-container';
      row.appendChild(col);
      variantsContainer.appendChild(row);
    }

    if (!variantsContainer.querySelector('.oa-qty-input')) {
      var qtyRow = document.createElement('div');
      qtyRow.className = 'row quantity-row variant-row';
      qtyRow.innerHTML = '<div class="col-xs-12 hidden"><p class="variant-label">&nbsp;</p></div>' +
        '<div class="col-xs-12">' +
        '<div class="input-group input-group-lg oa-qty-input">' +
        '<span class="input-group-btn"><button class="btn btn-default btn-dec" type="button"><i class="oa oa-minus-bts"></i></button></span>' +
        '<input type="number" name="quantity" min="1" class="qty-input form-control" value="1">' +
        '<span class="input-group-btn"><button class="btn btn-default btn-inc" type="button"><i class="oa oa-plus"></i></button></span>' +
        '</div></div>';
      variantsContainer.appendChild(qtyRow);
      bindQtyHandlers(qtyRow);
    }
  }

  function bindQtyHandlers(scope) {
    var group = scope.querySelector('.oa-qty-input');
    if (!group) return;
    var input = group.querySelector('.qty-input');
    var dec = group.querySelector('.btn-dec');
    var inc = group.querySelector('.btn-inc');
    var maxqty = 50;
    if (inc && input) inc.addEventListener('click', function() {
      var val = parseInt(input.value, 10) || 1;
      input.value = Math.min(val + 1, maxqty);
    });
    if (dec && input) dec.addEventListener('click', function() {
      var val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    });
    if (input) input.addEventListener('change', function() {
      if (parseInt(input.value, 10) > maxqty) input.value = maxqty;
    });
  }

  function updateSizes(product) {
    ensureVariantScaffold(product);
    var container = document.querySelector('.product-sizes-container');
    if (!container) return;

    var tags = product.tags || [];
    var variants = product.variants || [];
    var isDuallogo = hasTag(tags, 'duallogo');
    var has3lengths = hasTag(tags, '3lengths');
    var variantCount = variants.length;

    // Determine availability per length
    var isShortAvailable = false, isRegularAvailable = false, isLongAvailable = false;
    variants.forEach(function(v) {
      if (v.available) {
        if (v.title && v.title.indexOf('Regular') !== -1) isRegularAvailable = true;
        if (v.title && v.title.indexOf('Short') !== -1) isShortAvailable = true;
        if (v.title && v.title.indexOf('Long') !== -1) isLongAvailable = true;
      }
    });

    // Label translations
    var selectSizeLabel = lang === 'de' ? 'Wähle deine Grösse' : 'Select your size';
    var selectLengthLabel = lang === 'de' ? 'Wähle deine Länge' : 'Select your length';
    var logoLabel = lang === 'de' ? 'Logo Applikation' : 'Logo application';
    var sizeGuideLabel = lang === 'de' ? 'Grössenguide' : 'Size guide';

    var html = '';

    if (isDuallogo && variantCount > 20) {
      html = buildDuallogoWithLengths(product, variants, isShortAvailable, isRegularAvailable, isLongAvailable, selectLengthLabel, logoLabel, sizeGuideLabel, selectSizeLabel, tags);
    } else if (isDuallogo) {
      html = buildDuallogo(product, variants, logoLabel, sizeGuideLabel, selectSizeLabel, tags);
    } else if (variantCount < 9) {
      html = buildSimpleSizes(product, variants, selectSizeLabel, sizeGuideLabel, tags);
    } else {
      html = buildLengthSizes(product, variants, isShortAvailable, isRegularAvailable, isLongAvailable, has3lengths, selectLengthLabel, selectSizeLabel, sizeGuideLabel, tags);
    }

    // Preserve fitanalytics button if already injected (same sizes across colors)
    var fitaBtn = container.querySelector('#fitanalytics__button');

    container.innerHTML = html;

    if (fitaBtn) {
      container.appendChild(fitaBtn);
    }

    // Re-init size click handlers
    reinitSizeHandlers();
  }

  function sizeGuideHtml(label, tags) {
    var showAlways = hasTag(tags, 'launch_effortless_collection') || hasTag(tags, 'classicseamless2');
    return '<div class="product-sizes-sizeguide' + (showAlways ? ' visible-xs visible-sm visible-md visible-lg' : '') + '">' +
      '<a href="#" data-toggle="modal" class="sizeguide-trigger" data-target=".sizeguide-modal">' + label + ' <i class="fa fa-external-link"></i></a></div>';
  }

  function variantLi(v, cssClass, sizeName, displayName, showBreaks) {
    var disabled = !v.available ? ' disabled' : '';
    var svg = !v.available ? crossOutSvg : '';
    var display = showBreaks && displayName.indexOf(' -') !== -1 ? displayName.replace(' -', '<br>') : displayName;
    return '<li class="oa-product-sizes--item-size ' + cssClass + disabled + '"' +
      ' data-size-name="' + sizeName + '"' +
      ' data-sku="' + (v.sku || '') + '"' +
      ' data-size="' + v.id + '"' +
      ' data-title="' + (v.title || '') + '">' +
      svg + '<span>' + display + '</span></li>';
  }

  function buildSimpleSizes(product, variants, sizeLabel, guideLabel, tags) {
    var isAccessories = hasTag(tags, 'accessories');
    var html = '<div class="product-sizes-container--overlay"></div>' +
      '<div class="product-sizes-title">' + sizeLabel + '</div>' +
      sizeGuideHtml(guideLabel, tags) +
      '<ul class="product-sizes product-sizes-wrapper">';

    variants.forEach(function(v) {
      var name = v.title || v.option1 || '';
      var display = isAccessories ? name : name.replace('-', '<br>');
      html += variantLi(v, '', name, display, false);
    });

    html += '</ul>' +
      '<input type="hidden" name="id" data-productid="' + product.id + '" id="variant-id"' +
      (variants.length === 1 ? ' value="' + variants[0].id + '"' : '') + '>';
    return html;
  }

  function buildLengthSizes(product, variants, isShortAvail, isRegAvail, isLongAvail, has3lengths, lengthLabel, sizeLabel, guideLabel, tags) {
    var html = '<div class="product-sizes-title">' + lengthLabel + '</div>' +
      '<div class="product-sizes-container--overlay"></div>' +
      '<ul class="product-sizes product-length-wrapper">';

    if (has3lengths) {
      html += lengthItem('Short', 'short', isShortAvail, isShortAvail);
      html += lengthItem('Regular', 'regular', isRegAvail, !isShortAvail && isRegAvail);
      html += lengthItem('Long', 'long', isLongAvail, !isShortAvail && !isRegAvail);
    } else {
      var shortLabel = (isShortAvail && isRegAvail) ? 'Regular/Short' : (isShortAvail ? 'Short' : 'Regular');
      html += lengthItem(shortLabel, 'short', isShortAvail || isRegAvail, isShortAvail || isRegAvail);
      html += lengthItem('Long', 'long', isLongAvail, !(isShortAvail || isRegAvail));
    }

    html += '</ul>' +
      sizeGuideHtml(guideLabel, tags) +
      '<div class="product-sizes-title product-sizes-title-size">' + sizeLabel + '</div>' +
      '<ul class="product-sizes product-sizes-wrapper">';

    var showBreaks = variants.length > 4;
    variants.forEach(function(v) {
      var title = v.title || '';
      if (title.indexOf('Short') !== -1 || (!has3lengths && title.indexOf('Regular') !== -1)) {
        var sizeName = title.replace(/ - Short/g, '').replace(/ - Regular/g, '').trim();
        var display = showBreaks ? title.replace(' -', '<br>').replace(/ Short/g, '').replace(/ Regular/g, '').trim() : title.replace(/ Short/g, '').replace(/ Regular/g, '').replace(' -', '').trim();
        var hidden = '';
        if (has3lengths) {
          hidden = isShortAvail ? '' : ' product-sizes-hidden';
        } else {
          hidden = (isShortAvail || isRegAvail) ? '' : ' product-sizes-hidden';
        }
        html += variantLi(v, 'oa-product-sizes--item-size-short product-sizes-pdp' + hidden, sizeName, display, false);
      }
      if (has3lengths && title.indexOf('Regular') !== -1) {
        var sizeNameR = title.replace(/ - Regular/g, '').trim();
        var displayR = showBreaks ? title.replace(' -', '<br>').replace(/ Regular/g, '').trim() : title.replace(/ Regular/g, '').replace(' -', '').trim();
        var hiddenR = isShortAvail ? ' product-sizes-hidden' : (isRegAvail ? '' : ' product-sizes-hidden');
        html += variantLi(v, 'oa-product-sizes--item-size-regular product-sizes-pdp' + hiddenR, sizeNameR, displayR, false);
      }
      if (title.indexOf('Long') !== -1) {
        var sizeNameL = title.replace(/ - Long/g, '').trim();
        var displayL = showBreaks ? title.replace(' -', '<br>').replace(/ Long/g, '').trim() : title.replace(/ Long/g, '').replace(' -', '').trim();
        var hiddenL = (!isShortAvail && !isRegAvail) ? '' : ' product-sizes-hidden';
        html += variantLi(v, 'oa-product-sizes--item-size-long product-sizes-pdp' + hiddenL, sizeNameL, displayL, false);
      }
    });

    html += '</ul>' +
      '<input type="hidden" name="id" data-productid="' + product.id + '" id="variant-id">';
    return html;
  }

  function buildDuallogo(product, variants, logoLabel, guideLabel, sizeLabel, tags) {
    var html = '<div class="product-logos-title">' + logoLabel + '<span></span></div>';

    // Logo selector buttons (reuse existing product-logos snippet structure)
    html += '<ul class="product-sizes product-logos">' +
      '<li class="oa-product-logos--item active" data-selection-logo="engineered" data-selection-size="short">Knitted</li>' +
      '<li class="oa-product-logos--item" data-selection-logo="heat" data-selection-size="short">Printed</li>' +
      '</ul>';

    html += sizeGuideHtml(guideLabel, tags) +
      '<div class="product-sizes-title product-sizes-title-size">' + sizeLabel + '</div>' +
      '<ul class="product-sizes product-sizes-wrapper">';

    var showBreaks = variants.length > 4;
    variants.forEach(function(v) {
      var title = v.title || '';
      if (title.indexOf('Knitted logo') !== -1) {
        var sizeName = title.replace(/ - Knitted logo/g, '').trim();
        var display = showBreaks ? title.replace(' -', '<br>').replace(/ Knitted logo/g, '').trim() : title.replace(/ Knitted logo/g, '').replace(' -', '').trim();
        html += variantLi(v, 'oa-product-sizes--item-size-engineered', sizeName, display, false);
      }
      if (title.indexOf('Printed logo') !== -1) {
        var sizeNameP = title.replace(/ - Printed logo/g, '').trim();
        var displayP = showBreaks ? title.replace(' -', '<br>').replace(/ Printed logo/g, '').trim() : title.replace(/ Printed logo/g, '').replace(' -', '').trim();
        html += '<li style="display:none;" class="oa-product-sizes--item-size oa-product-sizes--item-size-heat' + (!v.available ? ' disabled' : '') + '"' +
          ' data-size-name="' + sizeNameP + '"' +
          ' data-sku="' + (v.sku || '') + '"' +
          ' data-size="' + v.id + '"' +
          ' data-title="' + (v.title || '') + '">' +
          (!v.available ? crossOutSvg : '') + '<span>' + displayP + '</span></li>';
      }
    });

    html += '</ul>' +
      '<input type="hidden" name="id" data-productid="' + product.id + '" id="variant-id">';
    return html;
  }

  function buildDuallogoWithLengths(product, variants, isShortAvail, isRegAvail, isLongAvail, lengthLabel, logoLabel, guideLabel, sizeLabel, tags) {
    var html = '<div class="product-sizes-title">' + lengthLabel + '</div>' +
      '<div class="product-sizes-container--overlay"></div>' +
      '<ul class="product-sizes product-length-wrapper">';

    var shortLabelDL = (isShortAvail && isRegAvail) ? 'Regular/Short' : (isShortAvail ? 'Short' : 'Regular');
    html += lengthItem(shortLabelDL, 'short', isShortAvail || isRegAvail, isShortAvail || isRegAvail);
    html += lengthItem('Long', 'long', isLongAvail, !(isShortAvail || isRegAvail));

    html += '</ul>';

    html += '<div class="product-logos-title">' + logoLabel + '<span></span></div>';
    html += '<ul class="product-sizes product-logos">' +
      '<li class="oa-product-logos--item active" data-selection-logo="engineered" data-selection-size="short">Knitted</li>' +
      '<li class="oa-product-logos--item" data-selection-logo="heat" data-selection-size="short">Printed</li>' +
      '</ul>';

    html += sizeGuideHtml(guideLabel, tags) +
      '<div class="product-sizes-title product-sizes-title-size">' + sizeLabel + '</div>' +
      '<ul class="product-sizes product-sizes-wrapper">';

    var defaultShortActive = isShortAvail || isRegAvail;
    variants.forEach(function(v) {
      var title = v.title || '';
      // Short - Knitted logo
      if (title.indexOf('Short - Knitted logo') !== -1) {
        var sn = title.replace(/ - Short - Knitted logo/g, '').trim();
        var hidden = defaultShortActive ? '' : ' product-sizes-hidden';
        html += variantLi(v, 'oa-product-sizes--item-size-engineered-short product-sizes-pdp' + hidden, sn, sn, false);
      }
      // Long - Knitted logo
      if (title.indexOf('Long - Knitted logo') !== -1) {
        var sn2 = title.replace(/ - Long - Knitted logo/g, '').trim();
        var hidden2 = defaultShortActive ? ' product-sizes-hidden' : '';
        html += variantLi(v, 'oa-product-sizes--item-size-engineered-long product-sizes-pdp' + hidden2, sn2, sn2, false);
      }
      // Short - Printed logo
      if (title.indexOf('Short - Printed logo') !== -1) {
        var sn3 = title.replace(/ - Short - Printed logo/g, '').trim();
        var hidden3 = defaultShortActive ? '' : ' product-sizes-hidden';
        html += variantLi(v, 'oa-product-sizes--item-size-heat-short product-sizes-pdp' + hidden3, sn3, sn3, false);
      }
      // Long - Printed logo
      if (title.indexOf('Long - Printed logo') !== -1) {
        var sn4 = title.replace(/ - Long - Printed logo/g, '').trim();
        var hidden4 = defaultShortActive ? ' product-sizes-hidden' : '';
        html += variantLi(v, 'oa-product-sizes--item-size-heat-long product-sizes-pdp' + hidden4, sn4, sn4, false);
      }
    });

    html += '</ul>' +
      '<input type="hidden" name="id" data-productid="' + product.id + '" id="variant-id">';
    return html;
  }

  function lengthItem(label, selectionSize, isAvailable, isActive) {
    return '<li class="oa-product-sizes--item' + (isActive ? ' active' : '') + '" data-selection-size="' + selectionSize + '">' +
      (!isAvailable ? crossOutSvg : '') + label + '</li>';
  }

  function reinitSizeHandlers() {
    // Re-run setupFashionView logic by triggering re-bind
    // We re-bind the click handlers that product-single.layout.js sets up
    var $input = jQuery('#variant-id');
    var $addToCartBtn = jQuery('.oa-product-addtocart-btn');
    var $sizeBtnsSelected = jQuery('.fashion-info-sticky ul.product-sizes li.oa-product-sizes--item-size');

    // Length/logo switch handler
    jQuery('.product-sizes .oa-product-sizes--item').not('#cts-modal .product-sizes .oa-product-sizes--item, #product-stl .product-sizes .oa-product-sizes--item').off('click').on('click', function() {
      var $selectedSize = jQuery('.oa-product-sizes--item-size.active').not('#cts-modal .oa-product-sizes--item-size.active, #product-stl .oa-product-sizes--item-size.active').attr('data-size-name');
      var $sizeSelection = jQuery(this).attr('data-selection-size');
      var $fashionVariant = jQuery('.oa-product-sizes--item-size-' + $sizeSelection + '[data-size-name="' + $selectedSize + '"]').not('#cts-modal .oa-product-sizes--item-size-' + $sizeSelection + '[data-size-name="' + $selectedSize + '"], #product-stl .oa-product-sizes--item-size-' + $sizeSelection + '[data-size-name="' + $selectedSize + '"]');
      var $wrapper = jQuery('.product-sizes-wrapper').not('#product-stl .product-sizes-wrapper');

      jQuery('.product-sizes .oa-product-sizes--item').not('#cts-modal .product-sizes .oa-product-sizes--item, #product-stl .product-sizes .oa-product-sizes--item').removeClass('active');
      $sizeBtnsSelected.removeClass('active');
      jQuery(this).addClass('active');
      jQuery('.oa-single-product_meta-container .product-length-wrapper').not('#cts-modal .product-length-wrapper, #product-stl .product-length-wrapper').removeClass('red');

      if (jQuery('.oa-single-product_meta-container .oa-product-sizes--item-size').hasClass('product-sizes-pdp')) {
        jQuery('.product-sizes-pdp').not('#cts-modal .product-sizes-pdp, #product-stl .product-sizes-pdp').addClass('product-sizes-hidden');
        jQuery('.product-sizes-pdp.oa-product-sizes--item-size-' + $sizeSelection).not('#cts-modal .product-sizes-pdp.oa-product-sizes--item-size-' + $sizeSelection, '#product-stl .product-sizes-pdp.oa-product-sizes--item-size-' + $sizeSelection).removeClass('product-sizes-hidden');
      } else {
        jQuery('.oa-single-product_meta-container .oa-product-sizes--item-size').not('#cts-modal .oa-product-sizes--item-size, #product-stl .oa-product-sizes--item-size').hide();
        jQuery('.oa-single-product_meta-container .oa-product-sizes--item-size-' + $sizeSelection).not('#cts-modal .oa-product-sizes--item-size-' + $sizeSelection, '#product-stl .oa-product-sizes--item-size-' + $sizeSelection).show();
      }

      jQuery('.oa-single-product_meta-container .product-sizes-title-size').not('#cts-modal .product-sizes-title-size, #product-stl .product-sizes-title-size').show();

      $wrapper.removeClass();
      $wrapper.addClass('product-sizes-wrapper product-sizes').addClass(jQuery('.oa-product-logos--item.active').attr('data-selection-logo')).addClass(jQuery('.oa-product-sizes--item.active').attr('data-selection-size'));

      if ($selectedSize !== undefined && !$fashionVariant.hasClass('disabled')) {
        $fashionVariant.addClass('active');
        if (jQuery('.oa-product-sizes--item').not('#cts-modal .oa-product-sizes--item, #product-stl .oa-product-sizes--item').hasClass('active') && jQuery('.oa-product-sizes--item-size').not('#cts-modal .oa-product-sizes--item-size, #product-stl .oa-product-sizes--item-size').hasClass('active')) {
          $addToCartBtn.attr('disabled', false);
          jQuery('.oa-single-product_meta-container #oa-fashion .fashion-info-flex #in-den-warenkorb').not('#oa-fashion #cts-modal .fashion-info-flex #in-den-warenkorb, #oa-fashion #product-stl .fashion-info-flex #in-den-warenkorb').removeClass('select');
          jQuery('.oa-single-product_meta-container .product-sizes').not('#cts-modal .product-sizes, #product-stl .product-sizes').removeClass('red');
          jQuery('.oa-single-product_meta-container .choose-size-alert').not('#cts-modal .choose-size-alert, #product-stl .choose-size-alert').hide(100);
          $input.val(jQuery('.oa-product-sizes--item-size.active').not('#cts-modal .oa-product-sizes--item-size.active, #product-stl .oa-product-sizes--item-size.active').attr('data-size'));
        }
      } else {
        if (jQuery('.oa-single-product_meta-container .oa-product-sizes--item-size.active').not('#cts-modal .oa-product-sizes--item-size.active, #product-stl .oa-product-sizes--item-size.active').length === 0) {
          $input.val('');
        }
      }
      if (jQuery('.oa-single-product_meta-container .oa-product-sizes--item-size.active').not('#cts-modal .oa-product-sizes--item-size.active, #product-stl .oa-product-sizes--item-size.active').length === 0) {
        $input.val('');
      }
    });

    // Logo switch handler
    jQuery('.product-logos .oa-product-logos--item').off('click').on('click', function() {
      var $selectedLogo = jQuery('.oa-product-sizes--item-size.active').attr('data-size-name');
      var $sizeSelection = jQuery(this).attr('data-selection-size');
      var $logoSelection = jQuery(this).attr('data-selection-logo');
      var $fashionVariant = jQuery('.oa-product-sizes--item-size-' + $sizeSelection + '[data-size-name="' + $selectedLogo + '"]');
      var $wrapper = jQuery('.product-sizes-wrapper');

      jQuery('.product-logos .oa-product-logos--item').removeClass('active');
      $sizeBtnsSelected.removeClass('active');
      jQuery(this).addClass('active');
      jQuery('.product-length-wrapper').not('#product-stl .product-length-wrapper').removeClass('red');
      jQuery('.oa-product-sizes--item-size').hide();
      jQuery('.oa-product-sizes--item-size-' + $logoSelection).show();
      jQuery('.product-sizes-title-size').show();

      $wrapper.removeClass();
      $wrapper.addClass('product-sizes-wrapper product-sizes').addClass(jQuery('.oa-product-logos--item.active').attr('data-selection-logo')).addClass(jQuery('.oa-product-sizes--item.active').attr('data-selection-size'));

      if ($selectedLogo !== undefined && !$fashionVariant.hasClass('disabled')) {
        $fashionVariant.addClass('active');
        if (jQuery('.oa-product-logos--item').hasClass('active') && jQuery('.oa-product-sizes--item-size').hasClass('active')) {
          $addToCartBtn.attr('disabled', false);
          jQuery('#oa-fashion .fashion-info-flex #in-den-warenkorb').removeClass('select');
          jQuery('.product-logos').removeClass('red');
          jQuery('.choose-size-alert').hide(100);
        }
      } else {
        if (jQuery('.oa-product-sizes--item-size.active').length === 0) {
          $input.val('');
        }
      }
      if (jQuery('.oa-product-sizes--item-size.active').length === 0) {
        $input.val('');
      }
    });

    // Size button click handlers
    $sizeBtnsSelected = jQuery('.fashion-info-sticky ul.product-sizes li.oa-product-sizes--item-size');
    $sizeBtnsSelected.off('click').on('click', function() {
      var $this = jQuery(this);
      var variant_id = $this.data('size');

      if (!$this.hasClass('disabled')) {
        $sizeBtnsSelected.removeClass('active');
        $this.addClass('active');
        jQuery('.product-sizes-wrapper').not('#product-stl .product-sizes-wrapper').removeClass('red');
        if (jQuery('.oa-product-sizes--item-size').hasClass('active')) {
          jQuery('.choose-size-alert').hide(100);
        }
        if (variant_id) {
          $addToCartBtn.attr('disabled', false);
          $input.val(variant_id);
          jQuery('#oa-fashion .fashion-info-flex #in-den-warenkorb').removeClass('select');
          document.dispatchEvent(new CustomEvent('oa:variantchange', {
            detail: { sku: $this.data('sku'), id: $this.data('size'), name: $this.data('title'), sizeName: $this.data('size-name') }
          }));
        }
      }
    });

    // Unbind original setupFashionView click handler (holds stale $input ref) and rebind with fresh ref
    jQuery('.oa-product-addtocart-btn:not(.oa-product-addtocart-btn-cts)').off('click').on('click', function(event) {
      if (jQuery('.oa-product-addtocart-btn').hasClass('early-access-cta')) return;
      var currentInput = jQuery('#variant-id');
      if (currentInput.val() === '') {
        event.preventDefault();
        if (jQuery('.oa-product-sizes--item').hasClass('active')) {
          jQuery('.product-sizes-wrapper').not('#product-stl .product-sizes-wrapper').addClass('red');
        } else if (jQuery('.oa-product-sizes--item-size').hasClass('active')) {
          jQuery('.product-length-wrapper').not('#product-stl .product-length-wrapper').addClass('red');
        } else {
          jQuery('.product-sizes').not('#product-stl .product-sizes').addClass('red');
        }
        jQuery('.choose-size-alert').show(100);
      }
    });
  }

  function reselectSize(sizeName, lengthSelection, logoSelection) {
    if (!sizeName) return;

    // Re-click the same length tab if it existed
    if (lengthSelection) {
      var lengthBtn = document.querySelector('.fashion-info-sticky .oa-product-sizes--item[data-selection-size="' + lengthSelection + '"]:not(#cts-modal .oa-product-sizes--item)');
      if (lengthBtn) jQuery(lengthBtn).trigger('click');
    }

    // Re-click the same logo tab if it existed
    if (logoSelection) {
      var logoBtn = document.querySelector('.product-logos .oa-product-logos--item[data-selection-logo="' + logoSelection + '"]');
      if (logoBtn) jQuery(logoBtn).trigger('click');
    }

    // Find and click the matching size button (must be visible and not disabled)
    var sizeButtons = document.querySelectorAll('.fashion-info-sticky .oa-product-sizes--item-size[data-size-name="' + sizeName + '"]:not(#cts-modal .oa-product-sizes--item-size)');
    for (var i = 0; i < sizeButtons.length; i++) {
      var btn = sizeButtons[i];
      // Must be visible (not hidden by length/logo filter) and not disabled
      if (!btn.classList.contains('product-sizes-hidden') && btn.offsetParent !== null && !btn.classList.contains('disabled')) {
        jQuery(btn).trigger('click');
        return;
      }
    }
  }

  function updateStockBadge(product) {
    var containers = document.querySelectorAll('.product-stock');
    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      if (container.classList.contains('product-us-tarrifs')) continue;
      var labelInstock = container.getAttribute('data-label-instock') || '';
      var labelOutofstock = container.getAttribute('data-label-outofstock') || '';
      if (product.available) {
        container.innerHTML = '<div class="product-instock"><span class="fa fa-circle"></span> ' + labelInstock + '</div>';
      } else {
        container.innerHTML = '<div class="product-outofstock"><span class="fa fa-circle"></span> ' + labelOutofstock + '</div>';
      }
    }
  }

  var cartIconSvgCache = null;
  function getCartIconSvg() {
    if (cartIconSvgCache !== null) return cartIconSvgCache;
    var existing = document.querySelector('.oa-product-addtocartbtn__carticon');
    if (existing) {
      cartIconSvgCache = existing.outerHTML;
    } else {
      cartIconSvgCache = '<svg class="oa-product-addtocartbtn__carticon" aria-hidden="true" focusable="false" role="img" viewBox="0 0 160 201.7" fill="currentColor"><path d="M159.9,186.5l-11.4-120c-0.6-7.7-7.5-14-15.3-14h-19.3v-20C113.9,14.6,98.4,0,80.4,0h-0.8C61.7,0,46.1,14.6,46.1,32.5v20H26.7c-7.7,0-14.5,6.3-15.3,14L0,186.5c-0.3,3.9,1,7.8,3.7,10.8c2.7,2.9,6.2,4.4,10.2,4.4H146c4.1,0,7.7-1.6,10.3-4.5C159.1,194.1,160.4,190.4,159.9,186.5z M58.9,52.5V32.4c0-10.9,9.9-19.8,20.8-19.8h0.8c10.9,0,20.8,8.9,20.8,19.8v20.1H58.9zM146.8,187.6c0,0.4-0.1,0.6-0.2,0.7l-0.1,0.1c-0.1,0.1-0.2,0.2-0.7,0.2h-132c-0.2,0-0.4-0.1-0.8-0.3c-0.2-0.2-0.2-0.4-0.1-0.7l11.4-120c0.1-0.9,1.3-2,2.2-2h106.7c1.1,0,2.1,1,2.2,2.1L146.8,187.6z"></path></svg>';
    }
    return cartIconSvgCache;
  }

  function buildInstockButton(isMobile, textInstock, textSoldout) {
    var btn = document.createElement('button');
    btn.type = 'submit';
    btn.id = 'in-den-warenkorb';
    btn.className = isMobile
      ? 'btn btn-lg oa-product-addtocart-btn mobile-addtocart-btn btn-cta select'
      : 'btn btn-lg oa-product-addtocart-btn btn-cta select';
    btn.setAttribute('data-text-instock', textInstock);
    btn.setAttribute('data-text-soldout', textSoldout);
    btn.innerHTML = '<span>' + textInstock + getCartIconSvg() + '</span>';
    return btn;
  }

  function buildSoldoutButton(isMobile, textSoldout) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = isMobile
      ? 'btn btn-lg oa-product-addtocart-btn btn-cta mobile-addtocart-btn btn-soldout'
      : 'btn btn-lg oa-product-addtocart-btn btn-cta oa-product-addtocart-btn--large btn-soldout';
    btn.textContent = textSoldout;
    return btn;
  }

  function updateBuy3Button(wrapper, product) {
    var hasB3 = hasTag(product.tags, 'buy-3-save-15');
    var existing = wrapper.querySelector('.btn-cta--underwearoffer');
    if (hasB3 && !existing && product.available) {
      var label = (lang === 'de') ? 'Kaufe 3 und erhalte -15%' : 'Buy 3 and save 15%';
      var div = document.createElement('div');
      div.className = 'btn btn-lg btn-cta btn-cta--rounded btn-cta--underwearoffer m-t-5';
      div.innerHTML = '<span>' + label + getCartIconSvg() + '</span>';
      var atcBtn = wrapper.querySelector('#in-den-warenkorb');
      if (atcBtn && atcBtn.nextSibling) {
        wrapper.insertBefore(div, atcBtn.nextSibling);
      } else {
        wrapper.appendChild(div);
      }
    } else if ((!hasB3 || !product.available) && existing) {
      existing.parentNode.removeChild(existing);
    }
  }

  function updateAddToCartWrapper(wrapper, product, hasReselected) {
    var isMobile = wrapper.classList.contains('is-sticky');
    var textInstock = wrapper.getAttribute('data-text-instock') || '';
    var textSoldout = wrapper.getAttribute('data-text-soldout') || '';
    var canSell = product.available && product.price > 0;
    var atcBtn = wrapper.querySelector('#in-den-warenkorb');
    var soldoutBtn = wrapper.querySelector('.btn-soldout');

    if (canSell) {
      if (!atcBtn) {
        var newBtn = buildInstockButton(isMobile, textInstock, textSoldout);
        if (soldoutBtn) {
          soldoutBtn.parentNode.replaceChild(newBtn, soldoutBtn);
        } else {
          wrapper.insertBefore(newBtn, wrapper.firstChild);
        }
        atcBtn = newBtn;
      } else {
        atcBtn.type = 'submit';
        atcBtn.classList.remove('btn-soldout');
        if (hasReselected) {
          atcBtn.classList.remove('select');
          atcBtn.disabled = false;
        } else {
          atcBtn.classList.add('select');
        }
        var span = atcBtn.querySelector('span');
        if (span) span.innerHTML = textInstock + getCartIconSvg();
      }
      updateBuy3Button(wrapper, product);
    } else {
      if (!soldoutBtn) {
        var newSoldoutBtn = buildSoldoutButton(isMobile, textSoldout);
        if (atcBtn) {
          atcBtn.parentNode.replaceChild(newSoldoutBtn, atcBtn);
        } else {
          wrapper.insertBefore(newSoldoutBtn, wrapper.firstChild);
        }
      } else {
        soldoutBtn.textContent = textSoldout;
      }
      updateBuy3Button(wrapper, product);
    }
  }

  function reinitAtcHandlers() {
    // Gate-keeper: block submit when no size selected. Mirrors product-single.layout.js:1227
    jQuery('.oa-product-addtocart-btn:not(.oa-product-addtocart-btn-cts)').off('click.oaAtcGate').on('click.oaAtcGate', function(event) {
      if (jQuery('.oa-product-addtocart-btn').hasClass('early-access-cta')) return;
      var currentInput = jQuery('#variant-id');
      if (currentInput.val() === '') {
        event.preventDefault();
        if (jQuery('.oa-product-sizes--item').hasClass('active')) {
          jQuery('.product-sizes-wrapper').not('#product-stl .product-sizes-wrapper').addClass('red');
        } else if (jQuery('.oa-product-sizes--item-size').hasClass('active')) {
          jQuery('.product-length-wrapper').not('#product-stl .product-length-wrapper').addClass('red');
        } else {
          jQuery('.product-sizes').not('#product-stl .product-sizes').addClass('red');
        }
        jQuery('.choose-size-alert').show(100);
      }
    });

    // Mobile sticky ATC scroll-up. Mirrors product-single.layout.js:1276
    jQuery('.is-sticky #in-den-warenkorb.select').off('click.oaAtcScroll').on('click.oaAtcScroll', function() {
      if (!jQuery(this).hasClass('select')) return;
      var fashionFlex = jQuery('.fashion-info-flex');
      if (!fashionFlex.length) return;
      jQuery([document.documentElement, document.body]).animate({
        scrollTop: fashionFlex.offset().top - 100
      }, 500);
    });
  }

  function updateAddToCart(product) {
    var input = document.getElementById('variant-id');
    var hasReselected = input && input.value !== '';

    // Only reset if reselectSize didn't already pick a size
    if (!hasReselected) {
      if (input) input.value = '';
      var sizeItems = document.querySelectorAll('.oa-product-sizes--item-size.active');
      for (var i = 0; i < sizeItems.length; i++) {
        sizeItems[i].classList.remove('active');
      }
    }

    var wrappers = document.querySelectorAll('.product-add-to-cart');
    for (var w = 0; w < wrappers.length; w++) {
      updateAddToCartWrapper(wrappers[w], product, hasReselected);
    }

    // Show/hide choose-size-alert
    var alerts = document.querySelectorAll('.choose-size-alert');
    for (var k = 0; k < alerts.length; k++) {
      if (product.available) {
        alerts[k].classList.remove('hidden');
        alerts[k].style.display = 'none';
      } else {
        alerts[k].classList.add('hidden');
      }
    }

    reinitAtcHandlers();
  }

  function updatePoints(product) {
    var containers = document.querySelectorAll('.points-container strong');
    for (var i = 0; i < containers.length; i++) {
      if (lang === 'de') {
        containers[i].textContent = product.price + ' Punkte';
      } else {
        containers[i].textContent = product.price + ' points';
      }
    }
  }

  function updateWishlist(product) {
    var wishlistBtns = document.querySelectorAll('.iWishAddColl');
    for (var i = 0; i < wishlistBtns.length; i++) {
      if (product.variants && product.variants[0]) {
        wishlistBtns[i].setAttribute('data-variant', product.variants[0].id);
      }
      wishlistBtns[i].setAttribute('data-product', product.id);
      wishlistBtns[i].setAttribute('data-ptitle', product.title);
    }
  }

  function updateTracking(product) {
    // Update dataLayer for GA
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'virtualPageview',
        page: '/products/' + product.handle,
        productId: product.id,
        productTitle: product.title
      });
    }

    // Update Nosto
    nostojs(function(api) { api.loadRecommendations(); });

    // Update Yotpo widget
    var yotpoEls = document.querySelectorAll('[data-yotpo-product-id]');
    for (var i = 0; i < yotpoEls.length; i++) {
      yotpoEls[i].setAttribute('data-yotpo-product-id', product.id);
    }
  }

  // --- Model Info (parsed from product tags) ---

  var isUsShop = document.documentElement.classList.contains('oa-us');

  function parseModelTag(tags) {
    if (!tags || !Array.isArray(tags)) return null;
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].indexOf('model:') === 0) {
        var parts = tags[i].split('|');
        var data = {};
        for (var p = 0; p < parts.length; p++) {
          var kv = parts[p].split(':');
          if (kv.length >= 2) data[kv[0]] = kv.slice(1).join(':');
        }
        // model:name_surname -> capitalize first part
        var rawName = (data.model || '').split('_')[0];
        data.modelName = rawName.charAt(0).toUpperCase() + rawName.slice(1);
        return data;
      }
    }
    return null;
  }

  function buildModelInfoText(data) {
    if (!data) return '';
    var name = data.modelName || '';
    var size = (data.size || '').toUpperCase();
    var heightCm = (data.height || '').replace('cm', ' cm');
    var heightIn = data.height_i || '';

    if (lang === 'de') {
      return 'Das Model (' + name + ') ist ' + heightCm + ' gro\u00df und tr\u00e4gt Gr\u00f6\u00dfe ' + size;
    }
    return 'Model (' + name + ') is ' + heightIn + ' (' + heightCm + ') and wears a size ' + size;
  }

  function buildModelTab6Html(data) {
    if (!data) return '';
    var heightLabel = lang === 'de' ? 'Modelgr\u00f6\u00dfe' : "Model's height";
    var hipsLabel = lang === 'de' ? 'H\u00fcfte' : 'Hips';
    var bustLabel = lang === 'de' ? 'Brustumfang' : 'Bust';
    var waistLabel = lang === 'de' ? 'Taille' : 'Waist';
    var unit = 'cm';

    var hips = parseFloat(data.hips) || 0;
    var bust = parseFloat(data.bust) || 0;
    var waist = parseFloat(data.waist) || 0;

    if (isUsShop) {
      hips = Math.round(hips / 2.54 * 10) / 10;
      bust = Math.round(bust / 2.54 * 10) / 10;
      waist = Math.round(waist / 2.54 * 10) / 10;
      unit = 'inch';
    }

    var infoText = buildModelInfoText(data);
    return '<p><b>' + heightLabel + ':</b> ' + infoText + '</p>' +
      '<p><b>' + hipsLabel + ':</b> ' + hips + ' ' + unit + '</p>' +
      '<p><b>' + bustLabel + ':</b> ' + bust + ' ' + unit + '</p>' +
      '<p><b>' + waistLabel + ':</b> ' + waist + ' ' + unit + '</p>';
  }

  function updateModelInfo(product) {
    var modelData = parseModelTag(product.tags);
    var modelText = buildModelInfoText(modelData);

    // Update key-features-list: find the row containing model info text
    var keyFeatures = document.querySelector('.key-features-list');
    if (keyFeatures) {
      var rows = keyFeatures.querySelectorAll('tr');
      for (var r = 0; r < rows.length; r++) {
        var td = rows[r].querySelector('td:last-child');
        if (td && (td.textContent.indexOf('Model') !== -1 || td.textContent.indexOf('model') !== -1 || td.textContent.indexOf('Das Model') !== -1 || td.textContent.indexOf('Das model') !== -1)) {
          if (modelText) {
            td.textContent = modelText;
          } else {
            rows[r].style.display = 'none';
          }
          break;
        }
      }
    }

    // Update Size & Fit tab (data-tab-content="3") — model height line
    var sizeFitTab = document.querySelector('[data-tab-content="3"] .tab-inner');
    if (sizeFitTab) {
      // Find <p> containing model height info (has <strong> with "Model" or "Modelgröße")
      var paragraphs = sizeFitTab.querySelectorAll('p');
      for (var pi = 0; pi < paragraphs.length; pi++) {
        var pText = paragraphs[pi].textContent;
        if (pText.indexOf('Model') !== -1 || pText.indexOf('model') !== -1 || pText.indexOf('Modelgr') !== -1) {
          if (modelText) {
            var heightLabel = lang === 'de' ? 'Modelgr\u00f6\u00dfe:' : "Model's height:";
            paragraphs[pi].innerHTML = '<strong>' + heightLabel + ' </strong>' + modelText;
          } else {
            paragraphs[pi].style.display = 'none';
          }
          break;
        }
      }
    }

    // Update Model Info tab (data-tab-content="6")
    var modelTabWrapper = document.querySelector('[data-tab="6"]');
    if (modelTabWrapper) {
      var modelTabWrapperParent = modelTabWrapper.parentElement;
      if (modelData && modelData.hips) {
        modelTabWrapperParent.style.display = '';
        var tabContent = document.querySelector('[data-tab-content="6"] .tab-inner');
        if (tabContent) {
          tabContent.innerHTML = buildModelTab6Html(modelData);
        }
      } else {
        modelTabWrapperParent.style.display = 'none';
      }
    } else if (modelData && modelData.hips) {
      // No model tab exists yet — inject one
      var desktopTab = document.querySelector('.desktop-tab');
      if (desktopTab) {
        var modelTabLabel = lang === 'de' ? 'Model-Details' : 'Model Info';
        var wrapper = document.createElement('div');
        wrapper.className = 'desktop-tab-wrapper';
        wrapper.innerHTML = '<div class="desktop-tab-headline" data-tab="6">' + modelTabLabel + '</div>' +
          '<div class="desktop-tab-content fade in" data-tab-content="6"><div class="tab-inner">' +
          buildModelTab6Html(modelData) + '</div></div>';
        desktopTab.appendChild(wrapper);
      }
    }
  }

  function updateEarlyAccessState(product) {
    var comingSoonTag = window.oaComingSoonHideTag;
    if (!comingSoonTag) return;

    var isComingSoon = hasTag(product.tags, comingSoonTag);

    // Disable/re-enable the server-rendered <style id="oa-coming-soon-styles"> that hides
    // .product-sizes-container, #in-den-warenkorb and .product-add-to-cart for coming-soon products
    var styleEl = document.getElementById('oa-coming-soon-styles');
    if (styleEl && styleEl.sheet) {
      styleEl.sheet.disabled = !isComingSoon;
    }

    // Also toggle d-none added by product.liquid on the wrapper elements
    var sizeContainers = document.querySelectorAll('.product-sizes-container');
    for (var i = 0; i < sizeContainers.length; i++) {
      sizeContainers[i].classList.toggle('d-none', isComingSoon);
    }

    var atcWrappers = document.querySelectorAll('.product-add-to-cart');
    for (var j = 0; j < atcWrappers.length; j++) {
      atcWrappers[j].classList.toggle('d-none', isComingSoon);
    }

    var countdown = document.getElementById('oa-product-sale-countdown');
    if (countdown) {
      countdown.style.display = isComingSoon ? '' : 'none';
    }
  }

  function updateSheerMessage(product) {
    var hasSheerTag = hasTag(product.tags, 'sheer');
    var unifiedEl = document.querySelector('.oa-unfied-sheer-msg');
    if (unifiedEl) {
      if (hasSheerTag) {
        unifiedEl.removeAttribute('hidden');
      } else {
        unifiedEl.setAttribute('hidden', '');
      }
    }

    var sheerEls = document.querySelectorAll('.oa-opacity-sheer, .oa-opacity-sheer-break');
    for (var i = 0; i < sheerEls.length; i++) {
      if (hasSheerTag) {
        sheerEls[i].removeAttribute('hidden');
      } else {
        sheerEls[i].setAttribute('hidden', '');
      }
    }
  }

  function updateSheerV2Message(product) {
    var semiSheerEls = document.querySelectorAll('.oa-opacity-semi-sheer, .oa-opacity-semi-sheer-break');
    if (semiSheerEls.length === 0) return;
    var hasSemiSheerTag = hasTag(product.tags, 'sheer_v2');
    for (var j = 0; j < semiSheerEls.length; j++) {
      if (hasSemiSheerTag) {
        semiSheerEls[j].removeAttribute('hidden');
      } else {
        semiSheerEls[j].setAttribute('hidden', '');
      }
    }
  }

  function updateOpaqueMessage(product) {
    var semiOpaqueEls = document.querySelectorAll('.oa-opacity-semi-opaque, .oa-opacity-semi-opaque-break');
    if (semiOpaqueEls.length === 0) return;
    var hasSheerOpacityTag = hasTag(product.tags, 'sheer_v2') || hasTag(product.tags, 'sheer');
    for (var j = 0; j < semiOpaqueEls.length; j++) {
      if (!hasSheerOpacityTag) {
        semiOpaqueEls[j].removeAttribute('hidden');
      } else {
        semiOpaqueEls[j].setAttribute('hidden', '');
      }
    }
  }

  // --- Loading State ---

  function showLoading() {
    var el = document.getElementById('oa-fashion');
    if (el) el.classList.add('oa-color-switching');
  }

  function hideLoading() {
    var el = document.getElementById('oa-fashion');
    if (el) el.classList.remove('oa-color-switching');
  }

  // --- Main API ---

  function switchColor(handle, opts) {
    opts = opts || {};
    if (!handle || handle === currentHandle || switching) return;

    switching = true;
    showLoading();

    var productFetch = OAProductsApi.fetchByHandles([handle]);
    var imagesFetch = fetch('/products/' + handle + '?view=pdp-images').then(function(r) { return r.text(); });
    // price_target isn't readable via the Storefront API (no metafield scope / password lock), so
    // pull it from the same Liquid view the quick-add uses. Only while the campaign is active.
    var metaFetch = window.oaPaScriptActive
      ? fetch('/products/' + handle + '?view=quickadd-meta').then(function(r) { return r.text(); }).catch(function() { return null; })
      : Promise.resolve(null);

    Promise.all([productFetch, imagesFetch, metaFetch]).then(function(results) {
      var product = results[0] && results[0][0];
      var imagesHtml = results[1];
      var metaText = results[2];

      if (!product) {
        // Fallback to normal navigation
        window.location.href = '/products/' + handle;
        return;
      }

      // Merge the PA metafield (price_target) so updateBadges can compute the PA discount.
      if (metaText) {
        try {
          var metaJson = JSON.parse(metaText);
          product.meta = metaJson.meta || metaJson;
        } catch (e) {}
      }

      // Capture current size selection before rebuilding
      var previousSizeName = null;
      var previousLength = null;
      var previousLogo = null;
      var activeSize = document.querySelector('.fashion-info-sticky .oa-product-sizes--item-size.active:not(#cts-modal .oa-product-sizes--item-size)');
      if (activeSize) previousSizeName = activeSize.getAttribute('data-size-name');
      var activeLength = document.querySelector('.fashion-info-sticky .oa-product-sizes--item.active:not(#cts-modal .oa-product-sizes--item)');
      if (activeLength) previousLength = activeLength.getAttribute('data-selection-size');
      var activeLogo = document.querySelector('.product-logos .oa-product-logos--item.active');
      if (activeLogo) previousLogo = activeLogo.getAttribute('data-selection-logo');

      // Run all updaters
      updateTitle(product);
      updateColorName(product);
      updatePrice(product);
      updateBadges(product);
      updateDesktopImages(imagesHtml);
      updateMobileSlider(imagesHtml);
      updateSizes(product);
      reselectSize(previousSizeName, previousLength, previousLogo);
      updateStockBadge(product);
      updateAddToCart(product);
      updateEarlyAccessState(product);
      updateFormProductId(product);
      updatePoints(product);
      updateWishlist(product);
      updateActiveColorSwatch(handle);
      updateUrl(handle, opts.pushState);
      updateTracking(product);
      updateModelInfo(product);
      updateSheerMessage(product);
      updateSheerV2Message(product);
      updateOpaqueMessage(product);

      currentHandle = handle;

      // Dispatch custom event for other scripts
      document.dispatchEvent(new CustomEvent('oa:colorswitch', { detail: { product: product, handle: handle } }));

    }).catch(function(err) {
      console.error('Color switch error:', err);
      window.location.href = '/products/' + handle;
    }).then(function() {
      switching = false;
      hideLoading();
    });
  }

  function preload(handles) {
    if (!handles || !handles.length) return;
    OAProductsApi.fetchByHandles(handles);
  }

  function init() {
    currentHandle = getHandleFromUrl();
    if (currentHandle) {
      history.replaceState({ handle: currentHandle }, '', window.location.href);
    }

    // Popstate handler for browser back/forward
    window.addEventListener('popstate', function(e) {
      if (e.state && e.state.handle) {
        switchColor(e.state.handle, { pushState: false });
      } else {
        var h = getHandleFromUrl();
        if (h) switchColor(h, { pushState: false });
      }
    });

    // Delegated click for dynamically-injected sold-out buttons
    document.addEventListener('click', function(e) {
      var btn = e.target.closest && e.target.closest('.btn-soldout');
      if (!btn) return;
      if (!window.sidebarBackInStock) return;
      e.preventDefault();
      window.sidebarBackInStock._data.show = true;
    });
  }

  // --- CSS for loading state ---
  var style = document.createElement('style');
  style.textContent = '#oa-fashion.oa-color-switching .oa-fashion__product-image-container,' +
    '#oa-fashion.oa-color-switching .oa-product-image-slider,' +
    '#oa-fashion.oa-color-switching .product-top-wrapper,' +
    '#oa-fashion.oa-color-switching .oa-product_price-section,' +
    '#oa-fashion.oa-color-switching .product-sizes-container,' +
    '#oa-fashion.oa-color-switching .product-add-to-cart {' +
    'opacity:0.5;transition:opacity 0.15s;pointer-events:none;}';
  document.head.appendChild(style);

  // --- Expose public API ---
  window.oaPdpColorSwitch = {
    init: init,
    switchColor: switchColor,
    preload: preload
  };

  // Auto-init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
